import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem("founder_access_token");
  if (!token) return <Navigate to="/founder/login" replace />;
  return <>{children}</>;
}
